import { render, staticRenderFns } from "./CardCourse.vue?vue&type=template&id=69945cc2&scoped=true"
import script from "./CardCourse.vue?vue&type=script&lang=js"
export * from "./CardCourse.vue?vue&type=script&lang=js"
import style0 from "./CardCourse.vue?vue&type=style&index=0&id=69945cc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69945cc2",
  null
  
)

export default component.exports